import React from 'react';
import { motion } from 'framer-motion';
//import {
//    FaReact,FaBrain, FaPython, FaDocker, FaUnity, FaGitAlt, FaLinux, FaNodeJs,
//    FaBlender, FaFigma, FaAdobe, FaVideo, FaMicrochip, FaVrCardboard,
//    FaFlask, FaTools , FaCloud
//} from 'react-icons/fa';
//import {
//    SiTailwindcss, SiMongodb, SiKubernetes, SiTensorflow, SiFirebase,
//    SiDjango, SiOpencv, SiAdobephotoshop,
//    SiAdobexd, SiIllustrator, SiAmazonwebservices
//} from 'react-icons/si';

import {
    FaReact, FaHtml5, FaCss3Alt, FaBootstrap, FaNodeJs, FaGitAlt, FaLinux, FaDocker, FaCloud, FaSlack, FaVideo, FaVrCardboard, FaTools, FaBlender, FaFigma, FaUnity, FaBrain, FaMicrochip, FaApple, FaMicrosoft, FaPython, FaFlask
} from 'react-icons/fa';

import {
    SiTailwindcss, SiFirebase, SiMongodb, SiTensorflow, SiOpencv, SiDjango, SiFastapi, SiAdobephotoshop, SiAdobeaftereffects,
    SiAmazonwebservices, SiKubernetes, SiNextdotjs, SiTypescript, SiJavascript, SiPytorch, SiScikitlearn, SiPandas,
    SiNumpy, SiKeras, SiGodotengine, SiCanva, SiGooglecloud, SiNetlify, SiVercel, SiGitlab, SiBitbucket, SiJira, SiPostgresql, SiUnrealengine,
    SiGoogle
} from 'react-icons/si';

import { GrMysql } from 'react-icons/gr';


const Technologies = () => {
    const techStacks = [
        {
            title: 'Frontend & Web',
            technologies: [
                { name: 'React', icon: <FaReact className="text-[#61DAFB]" /> },
                { name: 'Tailwind CSS', icon: <SiTailwindcss className="text-[#38B2AC]" /> },
                { name: 'Next.js', icon: <SiNextdotjs className="text-white" /> },
                { name: 'HTML5', icon: <FaHtml5 className="text-[#E34F26]" /> },
                { name: 'CSS3', icon: <FaCss3Alt className="text-[#1572B6]" /> },
                { name: 'JavaScript', icon: <SiJavascript className="text-[#F7DF1E]" /> },
                { name: 'TypeScript', icon: <SiTypescript className="text-[#3178C6]" /> },
                { name: 'Bootstrap', icon: <FaBootstrap className="text-[#7952B3]" /> }
            ]
        },
        {
            title: 'Backend & Python',
            technologies: [
                { name: 'Python', icon: <FaPython className="text-[#3776AB]" /> },
                { name: 'Flask', icon: <FaFlask className="text-[#000000]" /> },
                { name: 'Django', icon: <FaTools className="text-[#092E20]" /> },
                { name: 'FastAPI', icon: <SiFastapi className="text-[#009688]" /> },
                { name: 'Firebase', icon: <SiFirebase className="text-[#FFCA28]" /> },
                { name: 'Node.js', icon: <FaNodeJs className="text-[#339933]" /> },
                { name: 'Express.js', icon: <FaTools className="text-white" /> },
                { name: 'MongoDB', icon: <SiMongodb className="text-[#47A248]" /> },
                { name: 'PostgreSQL', icon: <SiPostgresql className="text-[#336791]" /> },
                { name: 'MySQL', icon: <GrMysql className="text-[#00758F]" /> }
            ]
        },
        {
            title: 'AI / ML / CV',
            technologies: [
                { name: 'TensorFlow', icon: <SiTensorflow className="text-[#FF6F00]" /> },
                { name: 'PyTorch', icon: <SiPytorch className="text-[#EE4C2C]" /> },
                { name: 'YOLO', icon: <FaBrain className="text-black" /> },
                { name: 'OpenCV', icon: <SiOpencv className="text-[#5C3EE8]" /> },
                { name: 'scikit-learn', icon: <SiScikitlearn className="text-[#F7931E]" /> },
                { name: 'Pandas', icon: <SiPandas className="text-[#150458]" /> },
                { name: 'NumPy', icon: <SiNumpy className="text-[#013243]" /> },
                { name: 'Keras', icon: <SiKeras className="text-[#D00000]" /> }
            ]
        },
        {
            title: 'Game & Simulation',
            technologies: [
                { name: 'Unity Engine', icon: <FaUnity className="text-black" /> },
                { name: 'Unreal Engine', icon: <SiUnrealengine className="text-white" /> },
                { name: 'Construct 3', icon: <FaTools className="text-white" /> },
                { name: 'Simulator Chairs', icon: <FaVrCardboard className="text-white" /> },
                { name: 'Godot', icon: <SiGodotengine className="text-[#478CBF]" /> },
                { name: 'Blender (Sim)', icon: <FaBlender className="text-[#F5792A]" /> }
            ]
        },
        {
            title: 'AR / VR / Hardware',
            technologies: [
                { name: 'Oculus / HTC Vive', icon: <FaVrCardboard className="text-white" /> },
                { name: 'FOVE VR', icon: <FaVrCardboard className="text-white" /> },
                { name: 'Kinect / Vuforia', icon: <FaVrCardboard className="text-white" /> },
                { name: 'Arduino / ESP / Jetson', icon: <FaMicrochip className="text-[#fca311]" /> },
                { name: 'Raspberry Pi', icon: <FaMicrochip className="text-[#b30b00]" /> },
                { name: 'Leap Motion', icon: <FaTools className="text-white" /> },
                { name: 'Google ARCore', icon: <SiGoogle className="text-[#4285F4]" /> },
                { name: 'Apple ARKit', icon: <FaApple className="text-white" /> }
            ]
        },
        {
            title: 'Creative & Design',
            technologies: [
                { name: 'Figma / Adobe XD', icon: <FaFigma className="text-[#A259FF]" /> },
                { name: 'Photoshop / Illustrator', icon: <SiAdobephotoshop className="text-[#31A8FF]" /> },
                { name: 'Premiere Pro', icon: <FaVideo className="text-[#9999FF]" /> },
                { name: 'After Effects', icon: <SiAdobeaftereffects className="text-[#9999FF]" /> },
                { name: 'Maya / 3ds Max', icon: <FaTools className="text-white" /> },
                { name: 'Blender', icon: <FaBlender className="text-[#F5792A]" /> },
                { name: 'Canva', icon: <SiCanva className="text-[#00C4CC]" /> }
            ]
        },
        {
            title: 'Cloud & DevOps',
            technologies: [
                { name: 'AWS', icon: <SiAmazonwebservices className="text-[#FF9900]" /> },
                { name: 'Docker', icon: <FaDocker className="text-[#2496ED]" /> },
                { name: 'Kubernetes', icon: <SiKubernetes className="text-[#326CE5]" /> },
                { name: 'Azure', icon: <FaCloud className="text-[#0078D4]" /> },
                { name: 'Google Cloud', icon: <SiGooglecloud className="text-[#4285F4]" /> },
                { name: 'Netlify', icon: <SiNetlify className="text-[#00C7B7]" /> },
                { name: 'Vercel', icon: <SiVercel className="text-white" /> }
            ]
        },
        {
            title: 'Version Control & Tools',
            technologies: [
                { name: 'Git / GitHub', icon: <FaGitAlt className="text-[#F1502F]" /> },
                { name: 'GitLab', icon: <SiGitlab className="text-[#FCA121]" /> },
                { name: 'Bitbucket', icon: <SiBitbucket className="text-[#0052CC]" /> },
                { name: 'Tortoise SVN', icon: <FaTools className="text-white" /> },
                { name: 'Microsoft Teams', icon: <FaMicrosoft className="text-[#6264A7]" /> },
                { name: 'Visual Studio', icon: <FaTools className="text-[#5C2D91]" /> },
                { name: 'Linux / Office Suite', icon: <FaLinux className="text-[#FCC624]" /> },
                { name: 'Jira', icon: <SiJira className="text-[#0052CC]" /> },
                { name: 'Slack', icon: <FaSlack className="text-[#4A154B]" /> }
            ]
        }
    ];


    return (
        <section id="technologies" className="relative min-h-screen bg-forest">
            {/* Diagonal split overlay */}
            <div className="absolute inset-0 z-0">
                <div className="absolute inset-0 bg-forest" />
                <div
                    className="absolute inset-0 bg-[#3D2314]"
                    style={{
                        clipPath: 'polygon(0 0, 100% 15%, 100% 100%, 0 85%)',
                    }}
                />
            </div>

            <div className="relative z-10 container mx-auto px-4 py-20">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-16"
                >
                    <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-accent-green mb-6">
                        Our Tech Stack
                    </h2>
                    <p className="text-cream text-lg md:text-xl max-w-3xl mx-auto">
                        From full-stack web development to embedded systems, AI, AR/VR, creative tools and DevOps � we master the technologies that move the future forward.
                    </p>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {techStacks.map((stack, stackIndex) => (
                        <motion.div
                            key={stack.title}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: stackIndex * 0.1 }}
                            className="bg-[#0A2F1D] p-6 rounded-lg border border-accent-green/20 hover:border-accent-green/50 transition-all"
                        >
                            <h3 className="text-xl font-semibold text-accent-green mb-6">
                                {stack.title}
                            </h3>
                            <div className="space-y-6">
                                {stack.technologies.map((tech) => (
                                    <div key={tech.name} className="flex items-center space-x-4">
                                        <div className="text-3xl">{tech.icon}</div>
                                        <span className="text-cream text-lg">{tech.name}</span>
                                    </div>
                                ))}
                            </div>
                        </motion.div>
                    ))}
                </div>

                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                    className="text-cream text-center mt-16"
                >
                    ...and many more, tailored to your project needs.
                </motion.p>
            </div>
        </section>
    );
};

export default Technologies;
